import { useEffect, useRef } from 'react';
import useIsMobile from 'hooks/useIsMobile';

interface EditableTextProps {
  isEditing: boolean;
  text: string;
  setText: (value: string) => void;
  textColor?: string;
}

const EditableText = ({ isEditing, text, setText, textColor }: EditableTextProps) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const isMobile = useIsMobile();

  // Adjust the height dynamically
  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Grow to fit content
    }
  };

  // Run height adjustment on text change & editing state change
  useEffect(() => {
    adjustHeight();
  }, [text, isEditing]);

  return (
    <textarea
      ref={textareaRef}
      aria-label={isEditing ? 'edit-dialogue' : 'text'}
      value={text}
      onChange={(e) => {
        setText(e.target.value);
        adjustHeight(); // Adjust height immediately as the user types
      }}
      disabled={!isEditing}
      className={`w-full min-h-0 ${textColor || 'text-text-primary'} sm:min-h-fit bg-transparent border-0 resize-none p-0
        focus:outline-none focus:ring-0 focus:border-none overflow-hidden
        ${isEditing && isMobile ? 'text-lg leading-relaxed' : ''}`}
      style={{
        WebkitAppearance: 'none',
        fontSize: isEditing && isMobile ? '16px' : '', // Prevents iOS zoom on focus
      }}
    />
  );
};

export default EditableText;
